import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as fromModel from '../../services/models';

@Component({
  selector: 'gp-delete-confirmation',
  templateUrl: './delete-confirmation.component.html',
  styleUrls: ['./delete-confirmation.component.scss']
})
export class DeleteConfirmationComponent implements OnInit, OnDestroy {

  name: string;
  deleteType: fromModel.DELETETYPE;

  constructor(
    private dialogRef: MatDialogRef<DeleteConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) private inputData: any) { 
      this.deleteType = inputData.deleteType;
      this.name = inputData.name;
    }

  ngOnInit(): void {
  }

  ngOnDestroy(): void{    
  }

  closeDialog(): void {
    this.dialogRef.close();    
  } 

  delete(){
    this.dialogRef.close(true);    
  }
}
